(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorPhotoBothController', EditorPhotoBothController);

    EditorPhotoBothController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'WxJS', 'Gallery', 'ItemValue', 'RecommendPics', 'Theme', '$localStorage', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'Store', 'Article', 'CommonService', '$http', 'ThemeClassify', 'MessageNotification', 'Product',
        'entity', 'StoreWorkEditConfig', '$translate','IMAGE_SUPPORTED_MIME','MessageService','StoreStorages','$websocket'];

    function EditorPhotoBothController($state, $scope, $q, $stateParams, Convert, Qinius, QiniuToken, WxJS, Gallery, ItemValue, RecommendPics, Theme, $localStorage, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, Store, Article, CommonService, $http, ThemeClassify, MessageNotification, Product,
                                       entity, StoreWorkEditConfig, $translate,IMAGE_SUPPORTED_MIME,MessageService,StoreStorages,$websocket) {
        //初始化
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        var vm = this;
        vm.isEdit = entity.type == 'edit' ? true : false;
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.productLine = {};
        $scope.domains = Qinius.getDomain();
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        PlatformWechatSetting.get({}, function (res) {
            vm.platformSetting = res.data;
        });
        vm.photoArray = [];
        vm.photoSelectAll = [];
        vm.isPhone = false;
        $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) != null ? JSON.parse(localStorage.getItem("gallery")) : [];
        $scope.status = localStorage.getItem('Production');
        vm.page1 = true;
        vm.page2 = false;
        vm.store = Store.get({id: vm.storeId});
        vm.photoAll = [];
        vm.loading = true;
        $scope.agentIos = false;
        vm.isIPhone6 = isIPhone6();
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        vm.duplicateList = []; //重复图片
        vm.isDuplicateList = false; //重复图片弹框
        vm.threeLoading = false;
        vm.threeLoadingText=$translate.instant("hint.loadingText");
        vm.backPhotoNotFilledMsg=$translate.instant("editorCommon.backPhotoNotFilled");
        vm.recommendPics = [];
        vm.deletePhotoSure = false; //删除处理失败照片确认框
        vm.pendingDeletePhoto = null; //待删除的处理失败照片

        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        /**
         * wechat api
         */

        // var ua = navigator.userAgent.toLowerCase();
        // if(ua.match(/MicroMessenger/i)=="micromessenger") {
        //     $scope.agentIos = browserVersions();
        // }

        $q.all([$scope.domains.$promise, vm.store.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            // token过期

            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = $translate.instant("language.zh-cn");
                    }
                    if (lang == 'en') {
                        langObj.value = $translate.instant("language.en");
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }

            // token过期 — QiniuToken 单例自动刷新
            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                // var url = "https://stage.fotavatar.com/10/143/1230321120340111/editorPhotoBoth";
                WxJS.get({url: url}, function (res) {
                    if (res.status == 200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            // wx.hideMenuItems({
                            //     menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            // });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }

            //判断是ios or Android
            function isIphoneX() {
                return /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 375 && (window.screen.height === 812 || window.screen.height == 724);
            }

            $scope.isIphoneX = isIphoneX();

            RecommendPics.getAllByCondition2({items:[{key: "cancelled", op: "=", value: "false"}],sort: ["seq,asc"]},function(res){
                if(res && res.data){
                    res.data.forEach(function(item){
                        item.identifier = $scope.domain + item.identifier;
                    })
                    vm.recommendPics = res.data;
                }
            })
            init();
            // $timeout(function () {
            //     qInit();
            // })
        websocket()
        });

        // websocket接收上传的图片（多端互通实时更新）
        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);
            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });
            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                console.log(photo);
                if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                    var _photo = null;
                    for (var i = 0; i < vm.photoAll.length; i++) {
                        if (vm.photoAll[i].id == photo.id) {
                            _photo = vm.photoAll[i];
                            break;
                        }
                    }
                    if (_photo) {
                        _photo.largeStatus = photo.largeStatus;
                        _photo.stripKey = photo.stripKey;
                        _photo.thumbnailKey = photo.thumbnailKey;
                        _photo.identifier1 = $scope.domain + photo.thumbnailKey
                        if(_photo.convertFlag){
                            _photo.convertStatus = photo.convertStatus;
                            // 色彩转换完成后资源identifier会变化，需同步更新（photo.identifier未带域名）
                            _photo.identifier = $scope.domain + photo.identifier;
                        }
                    }
                    var _photo1 = null;
                    for (var i = 0; i < vm.photoSelectAll.length; i++) {
                        if (vm.photoSelectAll[i].id == photo.id) {
                            _photo1 = vm.photoSelectAll[i];
                            break;
                        }
                    }
                    if (_photo1) {
                        _photo1.largeStatus = photo.largeStatus;
                        _photo1.stripKey = photo.stripKey;
                        _photo1.thumbnailKey = photo.thumbnailKey;
                        _photo1.identifier1 = $scope.domain + photo.thumbnailKey
                        if(_photo1.convertFlag){
                            _photo1.convertStatus = photo.convertStatus;
                            _photo1.identifier = $scope.domain + photo.identifier;
                        }
                    }
                    // 同步更新已选列表（图库已选tab）中的大图/色彩转换状态
                    if (vm.photoSelectAll1 && vm.photoSelectAll1.length) {
                        for (var k = 0; k < vm.photoSelectAll1.length; k++) {
                            if (vm.photoSelectAll1[k].id == photo.id) {
                                vm.photoSelectAll1[k].largeStatus = photo.largeStatus;
                                vm.photoSelectAll1[k].stripKey = photo.stripKey;
                                vm.photoSelectAll1[k].thumbnailKey = photo.thumbnailKey;
                                vm.photoSelectAll1[k].identifier1 = $scope.domain + photo.thumbnailKey;
                                if (vm.photoSelectAll1[k].convertFlag) {
                                    vm.photoSelectAll1[k].convertStatus = photo.convertStatus;
                                    vm.photoSelectAll1[k].identifier = $scope.domain + photo.identifier;
                                }
                            }
                        }
                    }
                    // 同步更新 imagebox.image 中的大图处理状态，确保编辑组件实时显示
                    if (vm.singleData) {
                        for (var sp = 0; sp < vm.singleData.length; sp++) {
                            var page = vm.singleData[sp];
                            if (page.levels && page.levels.level) {
                                for (var sl = 0; sl < page.levels.level.length; sl++) {
                                    var level = page.levels.level[sl];
                                    if (level.imagebox && level.imagebox.image &&
                                        level.imagebox.image.resourceid == photo.id) {
                                        level.imagebox.image.largeStatus = photo.largeStatus;
                                        level.imagebox.image.stripKey = photo.stripKey;
                                    }
                                }
                            }
                        }
                    }
                    vm.data.forEach(function(_data){
                        for (var sp = 0; sp < _data.length; sp++) {
                            var page = _data[sp];
                            if (page.levels && page.levels.level) {
                                for (var sl = 0; sl < page.levels.level.length; sl++) {
                                    var level = page.levels.level[sl];
                                    if (level.imagebox && level.imagebox.image &&
                                        level.imagebox.image.resourceid == photo.id) {
                                        level.imagebox.image.largeStatus = photo.largeStatus;
                                        level.imagebox.image.stripKey = photo.stripKey;
                                    }
                                }
                            }
                        }
                    })
                    $scope.$applyAsync();
                }
            });
            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });
            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }

        vm.isEditorPhotoUploadPopup = false;
        $scope.showGallery = function () {
            if(vm.product.editTip && vm.data.length == 0){
                vm.isEditorPhotoUploadPopup = true;
            }else{
                $scope.uploadPhoto(true)
            }
        }
        $scope.editorPhotoUploadPopupChange = function (){
            vm.isEditorPhotoUploadPopup = false;
            $scope.uploadPhoto(true)
        }
        vm.uploadPhotoItem=[];
        vm.isAddImg = false;
        $scope.uploadPhoto = function (type) {
            vm.isAddImg = type;
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    if($scope.agentIos){
                        $rootScope.$broadcast('clickAndroidUpload',true);
                    }else{
                        $timeout(function () {
                            $("#uploadImageMutiple-page0").trigger("click");
                        })
                    }
                }else{
                    if(res.status == 400){
                        threeInfo($translate.instant('editorCommon.systemError'));
                    } else {
                        threeInfo(res.data||$translate.instant('editorCommon.systemError'));
                    }
                }
            })
        }
        $scope.$on('uoloadFinished', function(event, args) {
            if(args){
                if (vm.isAddImg && vm.pictureType == 'spread' && vm.photoSelectAll && vm.photoSelectAll.length>0) {
                    if(vm.photoSelectAll && vm.photoSelectAll.length==1){
                        $scope.photoSave();
                    }else{
                        vm.page1 = false;
                        vm.page2 = true;
                    }
                }

                vm.photoAll = [];
                vm.indexNum = 0;
                vm.photoCompleted = false;
                loadAll('isNull');
            }
        });
        $scope.pageSortCb = function (text){
            vm.photoSelectAll = JSON.parse(text);
            vm.page1 = true;
            vm.page2 = false;
            if(vm.photoSelectAll && vm.photoSelectAll.length>0){
                $scope.photoSave();
            }
        }
        $scope.uploadPhotoCb = function (text){
            if(text){
                vm.photoAll.unshift(text)
            }
            if(vm.isAddImg && text){
                if(vm.pictureType == 'single'){
                    var img = text;
                    if(img && img.identifier){
                        abook([img])
                    }
                }
            }
        }

        // 监听重复图片事件
        $scope.$on('duplicateImages', function(event, duplicateList,flag,currentFileList) {
            if (duplicateList && duplicateList.length > 0) {
                vm.duplicateList = duplicateList;
                MessageService.confirm({
                    title: $translate.instant('hint.prompt'),
                    cancel: $translate.instant('button.cancel'),
                    confirm: $translate.instant('button.confirm'),
                    msg: $translate.instant('gallery.duplicateDetected', {count: vm.duplicateList.length}),
                    html: '<span class="themecolor themecolor-btn">' + $translate.instant('gallery.viewDuplicatePhotos') + '</span>'
                }, function(res) {
                    if (res == 'htmlClick') {
                        vm.isDuplicateList = true;
                    } else {
                        var ids = [];
                        vm.duplicateList.forEach(function(item) {
                            ids.push(item.id);
                        });
                        Gallery.batchDelete(ids, function() {
                            // 上传的全是重复图
                           if(ids.length == vm.photoAll.length){
                                MessageService.success($translate.instant('gallery.deduplicateSuccess'));
                                vm.duplicateList = [];
                                var deletedIds = {};
                                currentFileList.forEach(function(_v){
                                    if(_v.duplicate){
                                        deletedIds[_v.id] = true;
                                    }
                                });
                                vm.photoAll = vm.photoAll.filter(function(img){
                                    return !deletedIds[img.id];
                                });
                                vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                                    return !deletedIds[img.id];
                                });
                                vm.indexNum = 0;
                                vm.maxId = null;
                                vm.photoCompleted = false;
                                loadAll('isNull');
                           }else{
                            // 去重
                            var deletedIds = {};
                            currentFileList.forEach(function(_v){
                                if(_v.duplicate){
                                    deletedIds[_v.id] = true;
                                }
                            });
                            vm.photoAll = vm.photoAll.filter(function(img){
                                return !deletedIds[img.id];
                            });
                            vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                                return !deletedIds[img.id];
                            });
                            $rootScope.$broadcast('uoloadFinished',flag);
                           }
                        }, function(error) {
                            MessageService.error($translate.instant('gallery.deleteFailed'));
                            vm.duplicateList = [];
                        });
                    }
                }, function() {
                    vm.duplicateList = [];
                    $rootScope.$broadcast('uoloadFinished',flag);
                });
            }
        });
        $scope.duplicateChange = function(val) {
            var _val = JSON.parse(val)
            // val 可能是: 0(关闭), 1(全部删除), 数组(部分删除)
            // 当删除部分图片时，从已选列表中移除对应图片，避免重新加载后这些图片被重新选中
            if(Array.isArray(_val) && _val.length){
                var deletedIds = {};
                _val.forEach(function(_v){
                    deletedIds[_v.id] = true;
                });
                vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                    return !deletedIds[img.id];
                });
            }
            vm.isDuplicateList = false;
            vm.duplicateList = [];
            vm.photoAll = [];
            vm.indexNum = 0;
            vm.maxId = null;
            vm.photoCompleted = false;
            loadAll('isNull');
        };

        vm.itemsPerPage = 40;//分页数量
        function loadAll(folderId) {
            if (folderId == 'isNull') {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "isNull", value: ''}, {key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            } else {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "=", value: folderId}, {key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            }
        }

        function sorts() {
            return ["id,desc"];
        }

        function onSuccess(res) {
            for (var i = 0; i < res.data.length; i++) {
                if (!res.data[i].cancelled) {
                    res.data[i].identifier = $scope.domain + res.data[i].identifier;
                    if(res.data[i].largeFlag || $scope.isLarge(res.data[i].imageInfo)){
                        res.data[i].identifier1 = res.data[i].identifier + '.thumbnail.jpg';
                    }
                    vm.photoAll.push(res.data[i])
                }
            }
            if (res.data.length < vm.itemsPerPage) {
                vm.photoCompleted = true;
            }
            getPagePhoto();
        }

        function onError(data) {
            if(data.status !== 403){
                MessageService.hint($translate.instant("editorCommon.failedToObtainThePhotoGallery"));
            }
        }

        function getPagePhoto() {
            var timeList = [];
            vm.photoArray = [];
            for (var i = 0; i < vm.photoAll.length; i++) {
                var photoCreatedDate = new Date(vm.photoAll[i].createdDate);
                if (checkExist(timeList, photoCreatedDate)) {
                    timeList.push(photoCreatedDate);
                }
            }
            //将相同日期下的照片整合
            for (var m = 0; m < timeList.length; m++) {
                var tempObj = {};
                var tempItems = [];
                for (var j = 0; j < vm.photoAll.length; j++) {
                    var createdDate = new Date(vm.photoAll[j].createdDate);
                    if (timeList[m].getFullYear() == createdDate.getFullYear() &&
                        timeList[m].getMonth() == createdDate.getMonth() &&
                        timeList[m].getDate() == createdDate.getDate()) {
                        tempItems.push(vm.photoAll[j])
                    }
                }
                var time = timeList[m].getFullYear() + '-' + (timeList[m].getMonth() + 1) + '-' + timeList[m].getDate();
                tempObj = {"createDate": time, "galleries": tempItems};
                vm.photoArray.push(tempObj);
            }
            getPagePhotoSelected();
        }

        function getPagePhotoSelected() {
            for (var i = 0; i < vm.photoArray.length; i++) {
                for (var j = 0; j < vm.photoArray[i].galleries.length; j++) {
                    vm.photoArray[i].galleries[j].selected = false;
                    for (var k = 0; k < vm.photoSelectAll.length; k++) {
                        if (vm.photoArray[i].galleries[j].id == vm.photoSelectAll[k].id) {
                            vm.photoArray[i].galleries[j].selected = true;
                        }
                    }
                }
            }
            photoArrayAllSelect();
        }

        // 判断是否重复
        function checkExist(list, obj) {
            if (list == null || list.length == 0) {
                return true;
            }
            for (var i = 0; i < list.length; i++) {
                if (list[i].getFullYear() == obj.getFullYear() &&
                    list[i].getMonth() == obj.getMonth() &&
                    list[i].getDate() == obj.getDate()) {
                    return false;
                }
            }
            return true;
        }

        //全选当前图片
        $scope.photoAllCb = function (item) {
            item.selected = !item.selected ? true : false;
            for (var i = 0; i < item.galleries.length; i++) {
                item.galleries[i].selected = item.selected;
            }
            if (item.selected) {
                photoSelect()
            } else {
                item.galleries.forEach(function (gallerie) {
                    deletePhotoSelect(gallerie)
                })
            }
        }
        //选中当前图片
        $scope.photoOneCb = function (item) {
            item.selected = !item.selected ? true : false;
            if (item.selected) {
                photoSelect()
            } else {
                deletePhotoSelect(item);
            }
            photoArrayAllSelect();
        }

        function photoSelect() {
            // vm.photoSelectAll = [];
            // var photoSelectAll = angular.copy(vm.photoSelectAll);
            for (var i = 0; i < vm.photoArray.length; i++) {
                for (var j = 0; j < vm.photoArray[i].galleries.length; j++) {
                    if (vm.photoArray[i].galleries[j].selected) {
                        var isPhoto = false;
                        for (var k = 0; k < vm.photoSelectAll.length; k++) {
                            if (vm.photoSelectAll[k].id == vm.photoArray[i].galleries[j].id) {
                                isPhoto = true;
                                break
                            }
                        }
                        if (!isPhoto) {
                            vm.photoSelectAll.push(vm.photoArray[i].galleries[j])
                        }
                    }
                }
            }
        }

        function deletePhotoSelect(item) {
            var index = null;
            for (var i = 0; i < vm.photoSelectAll.length; i++) {
                if (vm.photoSelectAll[i].id == item.id) {
                    index = i;
                    break
                }
            }
            vm.photoSelectAll.splice(index, 1);
        }

        function photoArrayAllSelect() {
            for (var i = 0; i < vm.photoArray.length; i++) {
                vm.photoArray[i].selected = true;
                for (var j = 0; j < vm.photoArray[i].galleries.length; j++) {
                    if (!vm.photoArray[i].galleries[j].selected) {
                        vm.photoArray[i].selected = false;
                    }
                }
            }
        }

        $scope.photoIndex = function (item) {
            var index = null;
            for (var i = 0; i < vm.photoSelectAll.length; i++) {
                if (vm.photoSelectAll[i].id == item.id) {
                    index = i;
                    break
                }
            }
            return index + 1;
        }
        //添加图片
        $scope.photoSave = function () {
            vm.page1 = true;
            for (var i = 0; i < vm.photoSelectAll.length; i++) {
                vm.photoSelectAll[i].seq = i + 1;
            }
            abook(vm.photoSelectAll);
        }
        vm.windowDpi = js_getDPI();


        //主页
        vm.finalArray = [];
        vm.totalPrice = 0;
        vm.currentNavtab = 0;
        vm.product = {};
        vm.productXmlLines = [];

        function init() {
            if (!vm.isEdit) {
                Article.getByUser({id: $stateParams.aid}, function (article) {
                    if (article.status == 200) {
                        vm.article = article.data;
                        document.title = vm.article.productName;
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }
                        Product.get({id: vm.pid, cancelled: false}, function (res) {
                            var product = res.data;
                            vm.product = res.data;
                            vm.pictureType = res.data.pictureType;
                            if(!vm.pictureType){vm.pictureType = 'single'}
                            ItemValue.get({id: $stateParams.vid}, function (res1) {
                                vm.itemValue = res1.data;
                                getPropertyValue();
                                vm.productXmlLines = angular.copy(res1.data.productXmlLines);
                                vm.productXmlLine = angular.copy(res1.data.productXmlLines[0]);
                                angular.forEach(res1.data.productXmlLines, function (line) {
                                    if (line.id == vm.xmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                })

                                Gallery.all({
                                    items: [{key: "articleId", op: "=", value: vm.aid}],
                                    sort: sorts()
                                }, function (res){
                                    vm.photoSelectAll = [];
                                    if(res.data){
                                        res.data.forEach(function (item){
                                            item.galleries.forEach(function (gallerie){
                                                if (!gallerie.cancelled) {
                                                    gallerie.identifier = $scope.domain + gallerie.identifier;
                                                    vm.photoSelectAll.push(gallerie)
                                                }
                                            })
                                        })
                                    }
                                    getXmlToDucoment(vm.productXmlLine);
                                }, function (){

                                });
                            })
                        })
                    }
                },function(error){
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            } else {
                Article.getByUser({id: $stateParams.aid}, function (res) {
                    vm.article = res.data;
                    document.title = vm.article.productName;
                    if(vm.article.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                        return
                    }
                    ItemValue.get({id: res.data.itemValueId}, function (resp) {
                        vm.itemValue = resp.data;
                        getPropertyValue();
                        vm.article.skuNumber = resp.data.skuNumber;
                        vm.article.productBokeh = resp.data.productBokeh;
                        vm.article.productBokehType = resp.data.productBokehType;
                        vm.article.bokehtype = 'None';
                        vm.productXmlLines = [];
                        resp.data.productXmlLines.forEach(function (productXmlLine) {
                            if (!productXmlLine.cancelled) {
                                vm.productXmlLines.push(productXmlLine)
                            }
                        })
                        angular.forEach(vm.productXmlLines, function (line) {
                            if (line.productXmlId == vm.article.productXmlId) {
                                vm.productXmlLine = angular.copy(line);
                            }
                        });
                        getProduct(resp.data.productId, function () {
                            Convert.xmlToDocument2({
                                identifier: res.data.fileName,
                                provider: "qiniu",
                                editorType:vm.article.editorType,
                                pictureType:vm.pictureType,
                                // patternType:vm.product.patternType,
                            }, function (resp1) {
                                vm.counts = 0;
                                angular.forEach(resp1.pages.page, function (page, i) {
                                    if(!page.backup){
                                        angular.forEach(page.levels.level, function (level) {
                                            if (level.imagebox && level.imagebox.geometry) {
                                                vm.counts++;
                                            }
                                        })
                                    }
                                });
                                if (!resp1.pages.page || resp1.pages.page.length == 0) {
                                    swal({
                                        title: $translate.instant("font.warmPrompt"),
                                        text: $translate.instant("editorCommon.getTemplateError"),
                                        imageUrl: Theme.sweetHintImg(),
                                        timer: 3000,
                                        showConfirmButton: false
                                    });
                                    vm.placeOrder = false;
                                    return
                                }
                                $scope.template = angular.copy(resp1);
                                // 复制模板备份页面列表，避免直接修改原始数据
                                var backupPagesList = angular.copy($scope.template.backupPages.list);
                                // 过滤备份页面列表，只保留 uuid 等于模板页面的 uuid1 或 uuid2，并且 uuid 不为 null 的页面
                                backupPagesList = backupPagesList.filter(function(backupPage){
                                    return (backupPage.uuid == $scope.template.pages.uuid1 || backupPage.uuid == $scope.template.pages.uuid2) && backupPage.uuid != null
                                })
                                var mergedArray = $scope.template.pages.page.concat(backupPagesList);
                                $scope.template.pages.page = mergedArray;
                                documentAnalysis($scope, $http, vm, $scope.template, FontManagement, 'processing', function (page) {
                                    ratioInfo(page)
                                }, function () {
                                    $timeout(function () {
                                        var num = $scope.template.pages.page.length - backupPagesList.length;
                                        $scope.template.pages.page.splice(num);
                                        vm.loading = false;
                                        vm.windowH = window.innerHeight;
                                        vm.windowW = window.innerWidth;
                                        vm.placeOrder = true;
                                        vm.signalPage1 = $scope.template.pages.uuid1 ? getPage1($scope.template.pages.uuid1,$scope.template.pages.page,backupPagesList,0) : getPage('P0',$scope.template.pages.page);
                                        vm.signalPage2 = $scope.template.pages.uuid2 ? getPage1($scope.template.pages.uuid2,$scope.template.pages.page,backupPagesList,1) : getPage('P1',$scope.template.pages.page);
                                        imageboxQuantity();
                                        var documentPage = $scope.template.pages.page;
                                        vm.data = [];
                                        if (vm.pictureType == 'single') {
                                            for (var i = 0; i < documentPage.length; i++) {
                                                if(!documentPage[i].backup){
                                                    var isRepetition = false;
                                                    for (var j = 0; j < vm.data.length; j++) {
                                                        if (documentPage[i].uuid === vm.data[j].uuid) {
                                                            isRepetition = true;
                                                            vm.data[j].quantity++
                                                            break;
                                                        }
                                                    }
                                                    if (!isRepetition) {
                                                        documentPage[i].quantity = 1;
                                                        vm.data.push(documentPage[i])
                                                    }
                                                }
                                            }
                                            ;
                                        }
                                        if (vm.pictureType == 'spread') {
                                            var _data = [];
                                            for (var i = 0; i < documentPage.length; i++) {
                                                var _documentPage2 = documentPage[i];
                                                if(!_documentPage2.backup){
                                                    var isRepetition1 = false;
                                                    if (i % 2 === 0) {
                                                        //偶数
                                                        for (var j = 0; j < vm.data.length; j++) {
                                                            if (_documentPage2.uuid === vm.data[j][0].uuid) {
                                                                vm.data[j][0].quantity++;
                                                                isRepetition1 = true;
                                                                break;
                                                            }
                                                        }
                                                        if (!isRepetition1) {
                                                            _documentPage2.quantity = 1;
                                                            _data.push(_documentPage2);
                                                        }
                                                    } else if (i % 2 === 1) {
                                                        //奇数
                                                        if (_data.length > 0) {
                                                            _data.push(_documentPage2);
                                                            vm.data.push(_data);
                                                            _data = [];
                                                        }
                                                    }
                                                }
                                            }
                                            ;
                                        }
                                        if (vm.data.length > 0) {
                                            getCostMethod();
                                        }
                                        reserveInit($scope.template.pages.page)
                                        $scope.$apply();
                                    }, 1000)
                                })
                            });
                        })
                    });
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            }
        }

        function reserveInit(page) {
            var _page = angular.copy(page);
            vm.reservePage = [];
            _page.forEach(function (item) {
                if(item.backup){
                    vm.reservePage.push(item);
                }
            });
        }
        function getProduct(productId, callback) {
            Product.get({id: productId}, function (res) {
                vm.product = res.data;
                vm.pictureType = res.data.pictureType;
                if(!vm.pictureType){vm.pictureType = 'single'}
                if (callback) {
                    callback()
                }
            })
        }

        vm.templateView = false;
        $scope.productXmlLineClick = function (item) {
            if(item.productXmlId == vm.article.productXmlId){
                vm.threeIsModal1 = true;
                vm.threeModalText1 = $translate.instant("editorCommon.alreadyExistTemplate");
                return
            }
            vm.temporaryTemplate = item;
            vm.isTemplate = true;
        };
        $scope.threeModalHide = function(){
            vm.threeIsModal1 = false;
        }
        $scope.templateReplace = function (data) {
            var singleData = angular.copy(vm.data);
            vm.loading = true;
            vm.isTemplate = false;
            vm.article.cover = vm.temporaryTemplate.coverImg;
            vm.article.themeClassifyId = vm.temporaryTemplate.productXmlThemeId;
            vm.article.themeClassifyName = vm.temporaryTemplate.productXmlThemeName;
            vm.article.productXmlId = vm.temporaryTemplate.productXmlId;
            vm.article.productXmlName = vm.temporaryTemplate.productXmlName;
            vm.article.musicIdentify = vm.temporaryTemplate.musicIdentify;
            vm.article.itemValueId = vm.temporaryTemplate.itemValueId;
            getXmlToDucoment(vm.temporaryTemplate,function () {
                vm.counts = 0;
                angular.forEach($scope.template.pages.page, function (page, i) {
                    if(!page.backup){
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                            }
                        })
                    }
                });
                $scope.photos = [];
                vm.data = [];
                var _photo = [];
                var _photo1 = [];
                if (vm.pictureType == 'single') {
                    singleData.forEach(function (data) {
                        data.levels.level.forEach(function (level) {
                            if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                var photo = {
                                    identifier:level.imagebox.image.resource.identifier,
                                    width:level.imagebox.image.imgWidth,
                                    height:level.imagebox.image.imgHeight,
                                    imgSize:level.imagebox.image.size,
                                    imageInfo:level.imagebox.image.imageInfo,
                                    quantity:data.quantity,
                                    uuid:data.uuid,
                                    resourceid:level.imagebox.image.resourceid,
                                    id:level.imagebox.image.resourceid,
                                    sourceId:level.imagebox.image.resourceid
                                }
                                _photo.push(photo)
                            }
                        })
                    })
                }
                if (vm.pictureType == 'spread') {
                    singleData.forEach(function (singleData1) {
                        _photo1 = [];
                        singleData1.forEach(function (data, dataIndex) {
                            data.levels.level.forEach(function (level) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                    var photo = {
                                        identifier:level.imagebox.image.resource.identifier,
                                        width:level.imagebox.image.imgWidth,
                                        height:level.imagebox.image.imgHeight,
                                        imgSize:level.imagebox.image.size,
                                        imageInfo:level.imagebox.image.imageInfo,
                                        quantity:data.quantity,
                                        uuid:data.uuid,
                                        resourceid:level.imagebox.image.resourceid,
                                        id:level.imagebox.image.resourceid,
                                        sourceId:level.imagebox.image.resourceid
                                    }
                                    if(vm.sideUnification && dataIndex == 1){
                                        _photo1.push(photo)
                                    }else{
                                        _photo.push(photo)
                                    }
                                }
                            })
                        })
                    })
                }
                abook(_photo,function () {
                    if (vm.pictureType == 'spread' && _photo1.length > 0) {
                        vm.replacePageArrIndex = 0;
                        vm.replacePageIndex = 1;
                        if(vm.data[0] && vm.data[0][1] && vm.data[0][1].levels && vm.data[0][1].levels.level && vm.data[0][1].levels.level.length > 0){
                            vm.data[0][1].levels.level.forEach(function (level,levelIndex) {
                                if(_photo1[0]){
                                    vm.replaceTextIndex = levelIndex;
                                    replaceImagebox1(_photo1[0])
                                    _photo1.shift();
                                }
                            })
                        }
                        sideUnification()
                    }
                    $timeout(function () {
                        vm.loading = false;
                        vm.isTemplate = false;
                        vm.templateView = false;
                        vm.page1 = true;
                        vm.page3 = false;
                        vm.levelIndex = null;
                        getCostMethod()
                    }, 1000)
                })
            });
        }
        $scope.getBack = function (item) {
            vm.levelIndex = null;
            if (item == 'page2') {
                vm.page1 = true;
                vm.page2 = false;
            }
            if (item == 'page3') {
                vm.page1 = true;
                vm.page3 = false;
                scroll('page'+vm.singleIndex)
            }
            $scope.photoGalleryHide();
        };

        //获取模版信息
        function getXmlToDucoment(xml,callback) {
            vm.article.cover = xml.coverImg;
            vm.article.themeClassifyId = xml.productXmlThemeId;
            vm.article.themeClassifyName = xml.productXmlThemeName;
            vm.article.productXmlId = xml.productXmlId;
            vm.article.productXmlName = xml.productXmlName;
            vm.article.musicIdentify = xml.musicIdentify;
            vm.article.itemValueId = xml.itemValueId;
            getPropertyValue();
            Convert.xmlToDocument2({
                identifier: xml.productXmlIdentifier,
                provider: "qiniu",
                editorType:vm.article.editorType,
                pictureType:vm.pictureType,
            }, function (res) {
                vm.counts = 0;
                angular.forEach(res.pages.page, function (page, i) {
                    if(!page.backup){
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                            }
                        })
                    }
                });
                if (!res.status) {
                    if (!res.pages.page || res.pages.page.length == 0) {
                        swal({
                            title: $translate.instant("font.warmPrompt"),
                            text: $translate.instant("editorCommon.getTemplateError"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 3000,
                            showConfirmButton: false
                        });
                        vm.placeOrder = false;
                        return
                    }
                    $scope.template = angular.copy(res);
                    documentAnalysis($scope, $http, vm, $scope.template, FontManagement, 'processing', function (page) {
                        ratioInfo(page)
                    }, function () {
                        $timeout(function () {
                            vm.loading = false;
                            vm.placeOrder = true;
                            vm.signalPage1 = $scope.template.pages.uuid1 ? getPage1($scope.template.pages.uuid1,$scope.template.pages.page,$scope.template.backupPages.list,0) : getPage('P0',$scope.template.pages.page);
                            vm.signalPage2 = $scope.template.pages.uuid2 ? getPage1($scope.template.pages.uuid2,$scope.template.pages.page,$scope.template.backupPages.list,1) : getPage('P1',$scope.template.pages.page);
                            if(vm.article.editorType == 'PICTURE_PRO_P'){
                                if(vm.signalPage2.outline && vm.signalPage2.outline.mirrorCutline){
                                    vm.signalPage2.outline.cutline = angular.copy(vm.signalPage1.outline.mirrorCutline);
                                }
                                if(vm.propertyValue && vm.propertyValue.outline && vm.propertyValue.outline.length){
                                    if(vm.signalPage1.outline && vm.signalPage1.outline.cutline){
                                        if(!vm.signalPage1.outline.cutline.color){
                                            vm.signalPage1.outline.cutline.color = vm.propertyValue.outline[0].spotColor;
                                            vm.signalPage1.outline.cutline.colorValue = vm.propertyValue.outline[0].color;
                                        }
                                    }
                                    if(vm.signalPage2.outline && vm.signalPage2.outline.cutline){
                                        if(!vm.signalPage2.outline.cutline.color){
                                            vm.signalPage2.outline.cutline.color = vm.propertyValue.outline[0].spotColor;
                                            vm.signalPage2.outline.cutline.colorValue = vm.propertyValue.outline[0].color;
                                        }
                                    }
                                }
                            }
                            imageboxQuantity();
                            if(callback){
                                callback();
                                return
                            }
                            reserveInit($scope.template.pages.page)
                            abook(vm.photoSelectAll);
                        }, 1000)
                    })
                } else {
                    swal({
                        title: $translate.instant("font.warmPrompt"),
                        text: res.message,
                        imageUrl: Theme.sweetHintImg(),
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        }

        vm.ratioInfo = ratioInfo;

        function ratioInfo(item) {

            var windowRatio = 0.4;
            var windowRatio1 = 0.9;
            item.custom.ratio = $scope.dWidth * windowRatio / item.custom.width;
            // item.custom.ratio1 = $scope.dWidth * windowRatio1 / item.custom.width;


            vm.windowWidth = $(window).width() * 0.9;
            vm.windowHeight = $(window).height() - 300;
            var ratio = item.custom.width / item.custom.height;
            var ratio1 = vm.windowWidth / vm.windowHeight;
            if (ratio >= ratio1) {
                item.custom.ratio1 = vm.windowWidth / item.custom.width;
            } else {
                item.custom.ratio1 = vm.windowHeight / item.custom.height;
            }

            item.custom.thumbnailScale = 300 / item.custom.width;
        }

        vm.data = [];
        function imageboxQuantity(){
            if(vm.signalPage1){
                vm.signalPage1.imageboxQuantity = 0;
                vm.signalPage1.backup = false;
                if(vm.signalPage1.levels && vm.signalPage1.levels.level){
                    vm.signalPage1.levels.level.forEach(function (level) {
                        if (level.imagebox) {
                            level.imagebox.image = null;
                            vm.signalPage1.imageboxQuantity++;
                        }
                    })
                }
            }
            if(vm.signalPage2){
                vm.signalPage2.imageboxQuantity = 0;
                vm.signalPage2.backup = false;
                if(vm.signalPage2.levels && vm.signalPage2.levels.level){
                    vm.signalPage2.levels.level.forEach(function (level) {
                        if (level.imagebox) {
                            level.imagebox.image = null;
                            vm.signalPage2.imageboxQuantity++;
                        }
                    })
                }
            }
        }
        function abook(gallaryPic,callback) {
            var images = pageImagebox(gallaryPic);
            if(vm.pictureType == 'single'){
                var _pageCount = Math.ceil(images.length / vm.signalPage1.imageboxQuantity);
                for(var i = 0; i < _pageCount; i++){
                    var _page = JSON.parse(JSON.stringify(vm.signalPage1));
                    _page.quantity = 1;
                    _page.uuid = uuid();
                    vm.data.push(_page)
                }
                pageImagebox(images)
            }else{
                var _pageCount = Math.ceil(images.length / (vm.signalPage1.imageboxQuantity + vm.signalPage2.imageboxQuantity));
                if(vm.sideUnification && vm.signalPage1.imageboxQuantity){
                    _pageCount = Math.ceil(images.length / vm.signalPage1.imageboxQuantity);
                }
                for(var i = 0; i < _pageCount; i++){
                    var _page1 = JSON.parse(JSON.stringify(vm.signalPage1));
                    var _page2 = JSON.parse(JSON.stringify(vm.signalPage2));
                    _page1.quantity = 1;
                    _page1.uuid = uuid();
                    _page2.quantity = 1;
                    _page2.uuid = uuid();
                    vm.data.push([_page1,_page2])
                }
                pageImagebox(images)
                if(!callback && vm.sideUnification){
                    sideUnification()
                }
            }
            vm.photoSelectAll = [];
            if (vm.data.length > 0) {
                getCostMethod();
            }
            if(callback){callback()}
        }
        function pageImagebox(images){
            if(vm.pictureType == 'single'){
                for (var i2 = 0; i2 < vm.data.length; i2++) {
                    if (vm.data[i2].levels.level) {
                        for (var j = 0; j < vm.data[i2].levels.level.length; j++) {
                            var _level = vm.data[i2].levels.level[j];
                            if (images.length>0 && _level.imagebox) {
                                if ( !_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                    vm.replacePageIndex2 = i2;
                                    vm.replaceTextIndex = j;
                                    replaceImagebox1(images[0])
                                    images.shift();
                                }
                            }
                        }
                    }
                }
            }else{
                for (var i3 = 0; i3 < vm.data.length; i3++) {
                    for(var i1 = 0; i1<vm.data[i3].length; i1++){
                        if(vm.sideUnification && i1 ==0 || !vm.sideUnification){
                            var page2 = vm.data[i3][i1];
                            if (page2.levels.level) {
                                for (var j = 0; j < page2.levels.level.length; j++) {
                                    var _level = page2.levels.level[j];
                                    if (images.length>0 && _level.imagebox) {
                                        if ( !_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                            vm.replacePageArrIndex = i3;
                                            vm.replacePageIndex = i1;
                                            vm.replaceTextIndex = j;
                                            replaceImagebox1(images[0])
                                            images.shift();
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return images;
        }
        function replaceImagebox1(data){
            var item = angular.copy(data);
            if(vm.pictureType == 'single'){
                var _imagebox = vm.data[vm.replacePageIndex2].levels.level[vm.replaceTextIndex].imagebox;
            }else{
                var _imagebox = vm.data[vm.replacePageArrIndex][vm.replacePageIndex].levels.level[vm.replaceTextIndex].imagebox;
            }
            if(!_imagebox.bokehtype){
                _imagebox.bokehtype = 'None';
            }
            _imagebox.whiteInk = null;
            _imagebox.whiteInk2 = null;
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                offsetx:0,
                offsety:0,
                resourceid:item.sourceId,
                width: item.width,
                height: item.height,
                imageInfo: item.imageInfo,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
                largeFlag: item.largeFlag,
                largeStatus: item.largeStatus,
                convertFlag: item.convertFlag,
                convertStatus: item.convertStatus,
                stripKey: item.stripKey,
                thumbnailKey: item.thumbnailKey
            }
            _imagebox.blurredrectangle = {
                width: '',
                height: '',
                x: '',
                y: '',
            };
            if(vm.pictureType == 'spread'){
                getBlurredrectangle(_imagebox, $scope.zfInit() ? 1 : 0);
            }else{
                getBlurredrectangle(_imagebox, 0);
            }
        }

        function uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";

            var uuid = s.join("");
            return uuid;
        };

        function getBlurredrectangle(imagebox, index) {
            var item = imagebox;
            if (!item.image) {
                return
            }
            addImagebox($http, imagebox, function () {
                var newImg = angular.copy({
                    width: imagebox.image.width,
                    height: imagebox.image.height
                })
                if ((imagebox.geometry.width - imagebox.geometry.height) * (newImg.width - newImg.height) < 0) {
                    if (index % 2 === 0) {
                        if (imagebox.flip) {
                            imagebox.image.angle = imagebox.image.angle + 90;
                        } else {
                            imagebox.image.angle = imagebox.image.angle - 90;
                        }
                        imagebox.image.width = newImg.height;
                        imagebox.image.height = newImg.width;
                    }
                    if (index % 2 === 1) {
                        if (imagebox.flip) {
                            imagebox.image.angle = imagebox.image.angle - 90;
                        } else {
                            imagebox.image.angle = imagebox.image.angle + 90;
                        }
                        imagebox.image.width = newImg.height;
                        imagebox.image.height = newImg.width;
                    }
                } else {
                    imagebox.image.angle = imagebox.image.angle;
                }
                if(vm.product.bokehType != 'None'){
                    imagebox.bokehtype = 'Transparent';
                    imagebox.image.scale = 1;
                    if(imagebox.blurredrectangle){
                        imagebox.blurredrectangle.x = 0;
                        imagebox.blurredrectangle.y = 0;
                    }
                }
                getBackgroundSource3(imagebox, imagebox.geometry.width, imagebox.geometry.height, imagebox.image, imagebox.bokehtype, $scope);
            },true);
            photoSelectAllInit();
        }

        function getBlurredrectangle1(data, callback) {
            var item = data.levels.level[0].imagebox;
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = item.image.resource.identifier;
            newImg.onload = function () {
                item.image.width = newImg.width;
                item.image.height = newImg.height;
                callback()
            };
        }

        $scope.single = function (index, pageIndex) {
            if(vm.isCopyBack){return}
            vm.singleData = [];
            if(vm.article.editorType == 'PICTURE'){
                vm.levelIndex = 0;
            }
            if (vm.pictureType == 'single') {
                vm.singleData = angular.copy(vm.data);
                vm.singleIndex = index;
            }
            if (vm.pictureType == 'spread') {
                vm.data.forEach(function (data) {
                    data.forEach(function (page) {
                        vm.singleData.push(angular.copy(page))
                    })
                })
                vm.singleIndex = index * 2 + pageIndex;
            }
            vm.page1 = false;
            vm.page3 = true;
        }
        $scope.singleIndexClick = function (item) {
            if(vm.sideUnification){
                sideUnification(vm.singleIndex)
            }
            if(vm.article.editorType == 'PICTURE'|| vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P'){
                vm.levelIndex = 0;
            }
            if ($scope.zfInit() != item) {
                if (item) {
                    vm.singleIndex++
                } else {
                    vm.singleIndex--
                }
            }
            $scope.photoGalleryHide();
        }
        $scope.previousPage = function () {
            if (vm.pictureType == 'spread') {
                if(vm.sideUnification){
                    sideUnification(vm.singleIndex)
                }
                if (!$scope.zfInit()) {
                    vm.singleIndex -= 2;
                } else {
                    vm.singleIndex--
                }
            } else {
                vm.singleIndex--;
            }
            if (vm.singleIndex < 0) {
                vm.singleIndex = 0;
            }
            vm.levelIndex = 0;
            $scope.photoGalleryHide();
        }
        $scope.nextPage = function () {
            if (vm.pictureType == 'spread') {
                if(vm.sideUnification){
                    sideUnification(vm.singleIndex)
                }
                if (!$scope.zfInit()) {
                    vm.singleIndex += 2;
                } else {
                    vm.singleIndex++;
                }
            } else {
                vm.singleIndex++;
            }

            if (vm.singleIndex > vm.singleData.length - 1) {
                vm.singleIndex = vm.singleData.length - 1;
            }
            vm.levelIndex = 0;
            $scope.photoGalleryHide();
        }

        $scope.zfInit = function () {
            if (vm.singleIndex % 2 === 0) {
                return false
            } else if (vm.singleIndex % 2 === 1) {
                return true
            }
        }
        $scope.singleInit = function (index) {
            if (vm.pictureType == 'spread') {
                return Math.ceil(index / 2)
            }
            return index
        }
        $scope.subtractDeleteTab = function ($event, index) {
            vm.data.splice(index, 1);
            getCostMethod()
            fn($event)
        }
        $scope.subtractQuantityTab = function (data) {
            if (data.quantity > 1) {
                data.quantity--;
                getCostMethod()
            }
        }
        $scope.pushQuantityTab = function (data) {
            data.quantity++;
            getCostMethod()
        }
        $scope.quantityChange = function (data) {
            getCostMethod()
        }

        //获取价格
        function getCostMethod() {
            vm.totalCount = 0;
            for (var k = 0; k < vm.data.length; k++) {
                if (vm.pictureType == 'spread') {
                    vm.totalCount += vm.data[k][0].quantity;
                } else {
                    vm.totalCount += vm.data[k].quantity;
                }
            }
            vm.totalCount *= 2;
        }

        $scope.fillImagebox = function () {
            vm.singleData[vm.singleIndex].levels.level.forEach(function (level, i) {
                if (level.imagebox && i == vm.levelIndex) {
                    var item = level.imagebox;
                    item.bokehtype = 'Transparent';
                    item.image.scale = 1;
                    if(item.blurredrectangle){
                        item.blurredrectangle.x = 0;
                        item.blurredrectangle.y = 0;
                    }
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                    });
                }
            })
        }
        $scope.cutImagebox = function () {
            vm.singleData[vm.singleIndex].levels.level.forEach(function (level, i) {
                if (level.imagebox && i == vm.levelIndex) {
                    var item = level.imagebox;
                    item.bokehtype = 'None';
                    item.image.scale = 1;
                    if(item.blurredrectangle){
                        item.blurredrectangle.x = 0;
                        item.blurredrectangle.y = 0;
                    }
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                    });
                }
            })
        }
        $scope.rotateImagebox = function () {
            if (vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox) {
                var imagebox = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox;
                imageboxRotate($scope, imagebox);
            }
        }
        $scope.imageboxFlip = function(){
            if (vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox) {
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip = !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip;
            }
        }

        /*******************************************照片框处理*************************************************************************/
        var isImagebox = false;
        var stickerDragBox = {};
        window.moveImageboxStart = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var textIndex = targ.dataset.index;
            textIndex = parseInt(textIndex);
            vm.levelIndex = textIndex;
            var sticker = vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox;
            $scope.$apply();
            if (sticker.bokehtype != 'None') {
                return
            }

            stickerDragBox.x = e.changedTouches[0].clientX != null ? e.changedTouches[0].clientX : 0;          //鼠标到页面左边的距离
            stickerDragBox.y = e.changedTouches[0].clientY != null ? e.changedTouches[0].clientY : 0;          //鼠标到页面顶部的距离
            stickerDragBox.l = sticker.image.offsetx * vm.ratio1;
            stickerDragBox.t = sticker.image.offsety * vm.ratio1;
            stickerDragBox.r = -(sticker.image.width - vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox.geometry.width) * vm.ratio1;
            stickerDragBox.b = -(sticker.image.height - vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox.geometry.height) * vm.ratio1;
            isImagebox = true;
            $scope.$digest();
        }
        window.moveImageboxOn = function (e) {
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var textIndex = targ.dataset.index;
            textIndex = parseInt(textIndex);
            var sticker = vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox;
            if (vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox.bokehtype != 'None') {
                return
            }
            fn(e);
            var angle = Number(sticker.rotation.angle);
            var cx = (stickerDragBox.l + stickerDragBox.r) / 2;
            var cy = (stickerDragBox.t + stickerDragBox.b) / 2;
            var pt0 = rotatePoint({x: stickerDragBox.x, y: stickerDragBox.y}, {x: cx, y: cy}, -angle);
            var pt1 = rotatePoint({x: e.touches[0].pageX, y: e.touches[0].pageY}, {x: cx, y: cy}, -angle);
            var deltaX = pt1.x - pt0.x;
            var deltaY = pt1.y - pt0.y;
            var nl = stickerDragBox.l + deltaX;
            var nt = stickerDragBox.t + deltaY;
            if (nl < stickerDragBox.r) {
                nl = stickerDragBox.r
            }
            ;
            if (nl > 0) {
                nl = 0
            }
            ;
            if (nt < stickerDragBox.b) {
                nt = stickerDragBox.b
            }
            ;
            if (nt > 0) {
                nt = 0
            }
            ;

            sticker.image.offsetx = nl / vm.ratio1;
            sticker.image.offsety = nt / vm.ratio1;
            $scope.$digest();
        }
        window.moveImageboxEnd = function (e) {
            fn(e);
            isImagebox = false;
            stickerDragBox = {}
        }
        $scope.singleSave = function () {
            vm.levelIndex = null;
            vm.data = [];
            if (vm.pictureType == 'single') {
                vm.data = vm.singleData;
            }
            if (vm.pictureType == 'spread') {
                if(vm.sideUnification){
                    sideUnification(vm.singleIndex)
                }
                var _data = [];
                vm.singleData.forEach(function (data, index) {
                    if (index % 2 === 0) {
                        //偶数
                        _data.push(data);
                    } else if (index % 2 === 1) {
                        //奇数
                        _data.push(data);
                        vm.data.push(_data);
                        _data = [];
                    }
                })
            }
            vm.page1 = true;
            vm.page3 = false;
            $scope.photoGalleryHide();
            scroll('page'+vm.singleIndex)
        };

        function scroll(id){
            $timeout(function () {
                var _top = $("#"+id).offset().top-60;
                $("html, body").animate({
                    scrollTop: _top + "px"
                }, {
                    duration: 0,
                    easing: "swing"
                });
            })
            return false;
        }
        $scope.isSave = false;
        function articleOverdue(callback){
            Article.get({id: vm.article.id}, function (article) {
                if(article.data.fileName != vm.article.fileName){
                    MessageService.minConfirm({
                        cancel:$translate.instant("button.cancel"),
                        confirm:$translate.instant("button.refresh"),
                        msg:$translate.instant("hint.articleOverdue")
                    },function(){
                        $state.go("editorPhotoEdit", {storeId: vm.storeId, aid:  vm.article.id},{reload:true,location: 'replace'});
                    })
                }else{
                    callback();
                }
            })
        }

        $scope.saveTab = function () {
            if(!vm.data ||vm.data.length==0){
                MessageService.hint($translate.instant('editorCommon.pleaseAddImage'));
                return
            }
            articleOverdue(function () {
                var _data = [];
                var _data1 = angular.copy(vm.data);
                var pageCount = 0;
                if (vm.pictureType == 'single') {
                    angular.forEach(_data1, function (item) {
                        for (var i = 0; i < item.quantity; i++) {
                            var itemData = angular.copy(item);
                            _data.push(itemData)
                        }
                    });
                    _data.forEach(function (data) {
                        data.quantity = 1;
                    })
                    pageCount = _data.length;
                }
                if (vm.pictureType == 'spread') {
                    _data1.forEach(function (data) {
                        for (var i = 0; i < data[0].quantity; i++) {
                            _data.push(data[0])
                            _data.push(data[1])
                        }
                    })
                    _data.forEach(function (data) {
                        data.quantity = 1;
                    })
                    pageCount = _data.length/2;
                }
                vm.article.articleStatus = "EDITING";
                if (vm.article.multiple) {//先编辑
                    if(vm.article.expectPageCount && vm.article.expectPageCount >= 0){
                        if(pageCount % vm.article.expectPageCount === 0){
                            vm.article.articleStatus = "COMPLETED";
                        }else{
                            MessageService.hint($translate.instant('editorCommon.printQuantityInfo', {pageCount: pageCount, expectPageCount: vm.article.expectPageCount}));
                            return
                        }
                    }else{
                        vm.article.articleStatus = "COMPLETED";
                    }
                }else{//先下单
                    if(vm.article.expectPageCount && vm.article.expectPageCount >= 0){
                        if(pageCount > vm.article.expectPageCount){
                            MessageService.hint($translate.instant('editorCommon.photoCountExceeded', {max: vm.article.expectPageCount}));
                            return
                        }
                        if(pageCount == vm.article.expectPageCount){
                            vm.article.articleStatus = "COMPLETED";
                        }
                    }else{
                        vm.article.articleStatus = "COMPLETED";
                    }
                }
                for (var i = 0; i < _data.length; i++) {
                    var _page = _data[i];
                    if (_page.levels.level) {
                        for (var j = 0; j < _page.levels.level.length; j++) {
                            var _level = _page.levels.level[j];
                            if (_level.imagebox) {
                                if (!_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                    vm.article.articleStatus = "EDITING";
                                    break
                                }
                            }
                        }
                    }
                }
                if (!vm.placeOrder && !$scope.isSave) {
                    return
                }
                // 生成缩略图保存作品
                vm.threeLoading = true;
                thumbnailInit1(function () {
                    if (_data && _data.length > 0) {
                        var _page = [];
                        angular.forEach(_data, function (_data1) {
                            var item = angular.copy(_data1);
                            _page.push(item)
                        })
                        $scope.template.pages.page = _page;
                        $scope.template = documentMM($scope.template, null, null);
                        var backupPages = documentMM({pages:{page:[vm.signalPage1,vm.signalPage2]}}, null, null);
                        var list = $scope.template.backupPages && $scope.template.backupPages.list ? $scope.template.backupPages.list : [];
                        if(!list.some(function(item){return item.uuid == vm.signalPage1.uuid})){
                            list.push(backupPages.pages.page[0]);
                        }
                        if(!list.some(function(item){return item.uuid == vm.signalPage2.uuid})){
                            list.push(backupPages.pages.page[1]);
                        }
                        $scope.template.backupPages = {
                            list:list
                        }
                        $scope.isSave = true;
                        $scope.template.hostinfo = hostInfo();
                        $scope.template.pages.uuid1 = vm.signalPage1.uuid;
                        $scope.template.pages.uuid2 = vm.signalPage2.uuid;
                        Convert.articleUploadDocument($scope.template, function (res) {
                            vm.article.id = vm.aid;
                            vm.article.productType = 'CustomPrint';
                            vm.article.fileName = res.data.identifier;
                            vm.article.unFilledCount = 0;
                            vm.article.version = '2.0';
                            vm.article.pageCount = 0;
                            _page.forEach(function (itemPage) {
                                if(!itemPage.backup){
                                    vm.article.pageCount++
                                }
                            })
                            vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                            Article.update(vm.article, function (resp) {
                                vm.threeLoading = false;
                                $scope.isSave = false;
                                swal({
                                    title: $translate.instant("editorCommon.modifySuccess"),
                                    text: $translate.instant("editorCommon.synchronizationOfWorks"),
                                    imageUrl: Theme.sweetSuccedImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                $state.go("editorPhotoPreview", {storeId: vm.storeId, aid: resp.data.id},{location: 'replace'});
                            }, function () {
                                vm.threeLoading = false;
                                $scope.isSave = false;
                                swal({
                                    title: $translate.instant("editorCommon.saveError"),
                                    text: $translate.instant("editorCommon.saveError1"),
                                    imageUrl: Theme.sweetHintImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            })
                        }, function () {
                            $scope.isSave = false;
                            vm.threeLoading = false;
                            swal({
                                title: $translate.instant("editorCommon.saveError"),
                                text: $translate.instant("editorCommon.saveError1"),
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        })
                    }else{
                        vm.threeLoading = false;
                    }
                })
            })
        }
        function threeInfo(item) {
            vm.threeError = true;
            vm.threeErrorText = item;
            $timeout(function () {
                vm.threeError = false;
                vm.threeErrorText = "";
            }, 1500)
        }

        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if (res.status == 200) {
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        var throttledResize = angular.throttle(function (item) {
            console.log('No browser drain at each event please.');
            return pxInsufficient(item, vm.imgSize, vm.imgDpi)
        }, 1000);

        $scope.pxInsufficient = function (item) {
            // return throttledResize(item);
            return pxInsufficient(item, vm.imgSize, vm.imgDpi);
        }
        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function (imagebox, ratio, ratio1) {
            if (imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height = $scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox, width, height)
        }
        //图片框的操作
        $scope.imageboxSite = function (item) {
            if (!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] || vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.bokehtype != 'None') {
                return
            }
            var _imagebox = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox;
            if (item == 'center') {
                _imagebox.image.offsetx = -(_imagebox.image.width * _imagebox.image.scale - _imagebox.geometry.width) / 2 / _imagebox.image.scale;
                _imagebox.image.offsety = -(_imagebox.image.height * _imagebox.image.scale - _imagebox.geometry.height) / 2 / _imagebox.image.scale;
            }
            if (_imagebox.image.offsetx > 0) {
                _imagebox.image.offsetx = 0;
            }
            if (_imagebox.image.offsety > 0) {
                _imagebox.image.offsety = 0;
            }
        }

        //生成封面图
        function thumbnailInit1(callback) {
            $timeout(function () {
                html2canvas_adapt(document.getElementById('thumbnail-view1'), {
                    onrendered: function (canvas) {
                        if(canvas){
                            QiniuToken.uploadThumbnail(canvas, function (data) {
                                var identifier = data.key;
                                vm.article.covered = true;
                                vm.article.cover = identifier;
                                if (callback) {callback()};
                            }, function () {
                                vm.article.covered=false;
                                vm.article.cover=null;
                                if (callback) {callback()};
                            });
                        }else{
                            vm.article.covered=false;
                            vm.article.cover=null;
                            if (callback) {callback()};
                        }
                    },
                    error:function(){
                        vm.article.covered=false;
                        vm.article.cover=null;
                        if (callback) {callback()};
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $scope.template.pages.page[0].custom.width * $scope.template.pages.page[0].custom.thumbnailScale,
                    height: $scope.template.pages.page[0].custom.height * $scope.template.pages.page[0].custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            })
        }
        /*******************************************点击素材*************************************************************************/
        $scope.materialShow = function (){
            vm.isClassify = true;
        }
        vm.repeatAddNumber = 0;
        $scope.addMaterial = function (text){
            var item = JSON.parse(text);
            vm.singleData[vm.singleIndex].levels.level.push(item);
        }
        $scope.closeMaterial = function (text){
            vm.isClassify = false;
        }
        /*******************************************点击素材end*************************************************************************/
        /*******************************************文字*************************************************************************/
        //获取所有字体
        getAllFont();
        vm.fontList = [];
        function getAllFont() {
            vm.fontList = [];
            FontManagement.getAll({}, function (res) {
                vm.fontList = res;
            });
        }
        vm.textboxType = null;
        $scope.fontShow = function (){
            vm.textboxType = 'add';
        }
        $scope.textboxAdd = function (text){
            // var item = JSON.parse(text);
            $scope.photoGalleryHide();
        }
        $scope.textboxEdit = function (text){
            var item = JSON.parse(text);
            vm.singleData[vm.singleIndex].levels.level = item;
        }
        $scope.textboxDelete = function (){
            if (vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox) {
                vm.singleData[vm.singleIndex].levels.level.splice(vm.levelIndex, 1);
                $scope.photoGalleryHide()
            }
        }
        vm.sizeHeight1 = sizeHeight1;
        function sizeHeight1() {
            $timeout(function () {
                var _h = Number($("#c-xml-page-material-fontId1 span").height()) + Number(10);
                var _w = Number($("#c-xml-page-material-fontId1 span").width()) + Number(10);
                var _sizeWidth = getTextWidthInternal(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.text, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.bold, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.italic, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.size, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.fontuuid);
                if(!writingmodeInit(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.writingmode)){
                    vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.height = _h;
                    if(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width < vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.size){
                        vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.size;
                    }
                    if(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width < _sizeWidth){
                        item.geometry.width = (Number(_sizeWidth) + Number(5));
                        return;
                    }
                }
                if(writingmodeInit(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.writingmode)){
                    vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width = _w;
                    if(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.height < _sizeWidth){
                        vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.height = _sizeWidth;
                    }
                }
            })
        }
        /*******************************************文字end*************************************************************************/
        /*******************************************点击图片库*************************************************************************/
        vm.mapDepot = false;
        vm.isRecommend = false;
        $scope.photoGalleryShow = function (isRecommend) {
            vm.isRecommend = isRecommend;
            vm.mapDepot = true;
            vm.mapDepot2 = true;
            vm.mapDepot1 = false;
            if(!isRecommend){
                vm.photoAll = [];
                vm.indexNum = 0;
                vm.photoCompleted = false;
                loadAll('isNull');
            }else{
                ThemeClassify.getAllByCondition4({
                    type: 'RECOMMENDPIC',
                    storeId: vm.storeId
                }, function (res) {
                    if(res.data){
                        vm.recommendClassify = res.data;
                        vm.recommendClassifyItem = res.data[0];
                    }
                });
            }
        }

        vm.levelDome = function(item){
            vm.isClassify = false;
        }
        $scope.photoGalleryHide = function () {
            vm.mapDepot = false;
            vm.isClassify = false;
            vm.textboxSelect = false;
            vm.isLayout = false;
            vm.textboxType = null;
            if(vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P'){
                vm.levelIndex = null;
            }
        }
        $('#photoGallery').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.photoCompleted){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.indexNum++
                    loadAll("isNull")
                }
            }
        })
        var dragGal = {};
        var drag = false;
        var startChangeTimeout;
        vm.isSmallPic = false;
        window.startChange = function (e) {
            startChangeTimeout = setTimeout(function() {
                vm.isSmallPic = true;
                $scope.$digest();
            }, 200);
            drag = true;
            var i = e.target.dataset.imgindex;
            if(i >=0){
                if(vm.mapDepot1){
                    $scope.galleryArr = vm.photoSelectAll1[i];
                    $scope.galleryChoose = vm.photoSelectAll1[i].identifier;
                    if(vm.photoAll[i].largeFlag){
                        $scope.galleryChoose = vm.photoAll[i].identifier+'.thumbnail.jpg';
                    }
                }
                if(vm.isRecommend){
                    $scope.galleryArr = vm.recommendPics[i];
                    $scope.galleryChoose = vm.recommendPics[i].identifier;
                }else{
                    $scope.galleryArr = vm.photoAll[i];
                    $scope.galleryChoose = vm.photoAll[i].identifier;
                    if(vm.photoAll[i].largeFlag){
                        $scope.galleryChoose = vm.photoAll[i].identifier+'.thumbnail.jpg';
                    }
                }

                $scope.galleryId = i;
                $scope.galleryX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX - 53 : 0;
                $scope.galleryY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY - 40 : 0;
                dragGal.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
                dragGal.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
                dragGal.pageX = e.changedTouches[0].pageX ? e.changedTouches[0].pageX : 0;
                dragGal.pageY = e.changedTouches[0].pageY ? e.changedTouches[0].pageY : 0;
                dragGal.coordX = $scope.galleryX;
                dragGal.coordY = $scope.galleryY;
                $scope.$digest();
                return false;
            }
        };

        window.dragChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (drag) {
                //手指离开屏幕
                $scope.galleryX = (dragGal.coordX + (e.changedTouches[0].clientX - dragGal.clientX));
                $scope.galleryY = (dragGal.coordY + (e.changedTouches[0].clientY - dragGal.clientY));

                // if (Math.abs($scope.galleryY - dragGal.coordY) > 100) {
                //     vm.isSmallPic = true;
                // }


                //向上滑动;
                if ($scope.galleryY <= 0) {
                    $scope.galleryY = 0;
                }
                //向左滑动;        <-----
                if ($scope.galleryX <= 0) {
                    $scope.galleryX = 0;
                }
                //向下滑动;
                if ($scope.galleryY >= $scope.dHeight - 62) {
                    $scope.galleryY = $scope.dHeight - 62;
                }
                // 向右滑动;    ---->
                if ($scope.galleryX >= $scope.dWidth - 62) {
                    $scope.galleryX = $scope.dWidth - 62;
                }

                var _picTop = $("#small-pic").offset().top;
                var _picLeft = $("#small-pic").offset().left;
                var _exist = false;
                for (var i1 = vm.singleData[vm.singleIndex].levels.level.length-1; i1 >= 0; i1--) {
                    var _level = vm.singleData[vm.singleIndex].levels.level[i1];
                    if (_level.imagebox) {
                        var _imageboxLeft = $(".imagebox" + i1).offset().left;
                        var _imageboxTop = $(".imagebox" + i1).offset().top;
                        var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                        var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                        if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight) && !_exist) {
                            _exist = true;
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(103, 106, 108, 0.8)")
                            break;
                        }else{
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(0,0,0,0.2)")
                        }
                    }
                }
                $scope.$digest();
                return false;
            }
        };
        window.stopChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (!drag) {
                return
            }
            drag = false;
            var _picTop = $("#small-pic").offset().top;
            var _picLeft = $("#small-pic").offset().left;
            for (var i1 = vm.singleData[vm.singleIndex].levels.level.length-1; i1 >= 0; i1--) {
                var _level = vm.singleData[vm.singleIndex].levels.level[i1];
                if (_level.imagebox) {
                    var _imageboxLeft = $(".imagebox" + i1).offset().left;
                    var _imageboxTop = $(".imagebox" + i1).offset().top;
                    var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                    var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                    if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight)) {
                        $scope.replaceImagebox1($scope.galleryArr, i1)
                        break;
                    }
                }
            }
            vm.isSmallPic = false;
            $scope.$digest();
        };

        $scope.replaceImagebox1 = function (data, index) {
            vm.levelIndex = index;
            replaceImagebox(data)
        }

        function replaceImagebox(data, callback) {
            var item = angular.copy(data);
            var _imagebox = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox;
            _imagebox.whiteInk = null;
            _imagebox.whiteInk2 = null;
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                resourceid:item.sourceId,
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                imageInfo: item.imageInfo,
                width: item.width,
                height: item.height,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
                largeFlag: item.largeFlag,
                largeStatus: item.largeStatus,
                convertFlag: item.convertFlag,
                convertStatus: item.convertStatus,
                stripKey: item.stripKey,
                thumbnailKey: item.thumbnailKey
            }
            _imagebox.blurredrectangle = {
                width: '',
                height: '',
                x: '',
                y: '',
            };
            if(vm.pictureType == 'spread'){
                getBlurredrectangle(_imagebox, $scope.zfInit() ? 1 : 0);
            }else{
                getBlurredrectangle(_imagebox, 0);
            }
        }
        function photoSelectAllInit() {
            vm.photoSelectAll1 = [];
            if(vm.singleData){
                vm.singleData.forEach(function (page) {
                    page.levels.level.forEach(function (level) {
                        if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                            var _img = level.imagebox.image;
                            var photo = {
                                identifier:_img.resource.identifier,
                                width:_img.imgWidth,
                                height:_img.imgHeight,
                                imgSize:_img.size,
                                imageInfo:_img.imageInfo,
                                resourceid:_img.resourceid,
                                id:_img.resourceid,
                                largeFlag:_img.largeFlag,
                                largeStatus:_img.largeStatus,
                                convertFlag:_img.convertFlag,
                                convertStatus:_img.convertStatus,
                                stripKey:_img.stripKey,
                                thumbnailKey:_img.thumbnailKey
                            }
                            // 大图/色彩转换需要展示缩略图identifier1
                            if(photo.largeFlag || photo.thumbnailKey){
                                photo.identifier1 = photo.largeFlag
                                    ? (photo.identifier + '.thumbnail.jpg')
                                    : ($scope.domain + photo.thumbnailKey);
                            }
                            var _is = false;
                            for(var i=0; i<vm.photoSelectAll1.length; i++){
                                if(vm.photoSelectAll1[i].id == level.imagebox.image.resourceid){
                                    _is = true;
                                    break
                                }
                            }
                            if(!_is){
                                vm.photoSelectAll1.push(photo)
                            }
                        }
                    })
                })
            }
        }

        $scope.addImageboxImg = function (item) {
            if(vm.singleData && vm.singleData[vm.singleIndex] && vm.singleData[vm.singleIndex].levels.level && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox){
                replaceImagebox(item)
            }
        };

        // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
        $scope.photoStatus = function (photo) {
            if (!photo) return '';
            if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
            if (photo.convertStatus == 'error') return 'convertError';
            if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
            if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
            return '';
        };
        // 是否处理失败状态（大图处理失败、色彩转换失败）
        $scope.isPhotoFailed = function (photo) {
            var status = $scope.photoStatus(photo);
            return status === 'largeError' || status === 'convertError';
        };
        // 处理中的照片不可选中/添加到画布，处理失败的照片点击弹出删除确认框
        $scope.onPhotoStatusClick = function (photo, event) {
            if (event) {
                event.stopPropagation();
            }
            if ($scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        };
        // 确认删除处理失败的照片，取消则仅关闭弹框
        $scope.deletePhotoConfirm = function () {
            var photo = vm.pendingDeletePhoto;
            if (!photo || !photo.id) {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                return;
            }
            var id = photo.id;
            Gallery.batchDelete([id], function () {
                MessageService.success($translate.instant('nav.photograph.content.deletePhoto.success'));
                // 清除画布中引用该照片的图片框（兼容 single/spread 两种 pages 结构）
                var clearCanvasRefs = function (pages) {
                    if (!pages || !pages.length) return;
                    angular.forEach(pages, function (pageItem) {
                        // spread 类型 pageItem 为 [frontPage, versoPage] 数组；single 类型 pageItem 为单页对象
                        var pageList = Array.isArray(pageItem) ? pageItem : [pageItem];
                        angular.forEach(pageList, function (page) {
                            if (page && page.levels && page.levels.level) {
                                angular.forEach(page.levels.level, function (level) {
                                    if (level.imagebox && level.imagebox.image &&
                                        (level.imagebox.image.resourceid == id ||
                                        (photo.sourceId != null && level.imagebox.image.resourceid == photo.sourceId))) {
                                        var box = level.imagebox;
                                        box.blurredrectangle = {
                                            x: 0,
                                            y: 0,
                                            width: box.geometry ? box.geometry.width : '',
                                            height: box.geometry ? box.geometry.height : ''
                                        };
                                        box.imgUrl = 'content/images/mask_souce.png';
                                        box.image = {
                                            resource: {
                                                identifier: '',
                                                provider: ''
                                            },
                                            filterResource: {
                                                identifier: '',
                                                provider: ''
                                            },
                                            offsetx: 0,
                                            offsety: 0,
                                            width: '',
                                            height: '',
                                            imgsize: '',
                                            index: '',
                                            parameter: [],
                                            scale: 1,
                                            angle: 0
                                        };
                                    }
                                });
                            }
                        });
                    });
                };
                if (vm.singleData && vm.singleData.length) {
                    clearCanvasRefs(vm.singleData);
                }
                if (vm.data && vm.data.length) {
                    clearCanvasRefs(vm.data);
                }
                // 从本地图库列表及已选集合中移除
                var removeFromList = function (list) {
                    if (!list || !list.length) return;
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (list[i].id === id) {
                            list.splice(i, 1);
                        }
                    }
                };
                removeFromList(vm.photoAll);
                removeFromList(vm.photoSelectAll);
                removeFromList(vm.photoSelectAll1);
                getPagePhoto();
                photoSelectAllInit();
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
            }, function () {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                MessageService.error($translate.instant('nav.photograph.content.deletePhoto.failed'));
            });
        };

        // 子组件点击处理失败的照片时emit此事件，由父级弹出删除确认框
        $scope.$on('requestDeletePhoto', function (event, photo) {
            if (photo && $scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        });

        //复制背面
        vm.isCopyBack = false;
        vm.copyBackIndex == null;
        $scope.copyBack = function($event, index){
            fn($event)
            vm.isCopyBack = true;
            vm.copyBackIndex = index;
        }
        $scope.copyHide = function(){
            vm.isCopyBack = false;
            vm.copyBackIndex == null;
            vm.data.forEach(function(data){
                data[1].isCopyBack = false;
            })
        }
        $scope.copyAll = function(){
            vm.data.forEach(function(data,dataIndex){
                if(dataIndex != vm.copyBackIndex){
                    var outline = JSON.parse(JSON.stringify(data[1].outline));
                    data[1] = JSON.parse(JSON.stringify(vm.data[vm.copyBackIndex][1]));
                    data[1].uuid = uuid();
                    data[1].outline = outline;
                    data[1].isCopyBack = true;
                }
            })
            MessageService.hint($translate.instant("editorCommon.copySuccess"))
        }
        $scope.editorPageCopyHere = function($event, index){
            fn($event)
            var outline = JSON.parse(JSON.stringify(vm.data[index][1].outline));
            vm.data[index][1] = JSON.parse(JSON.stringify(vm.data[vm.copyBackIndex][1]));
            vm.data[index][1].uuid = uuid();
            vm.data[index][1].outline = outline;
            vm.data[index][1].isCopyBack = true;
            MessageService.hint($translate.instant("editorCommon.copySuccess"))
        }
        //布局库
        vm.isLayout = false;
        $scope.reserveShow = function(){
            vm.isLayout = true;
        }
        $scope.layoutCb = function(item){
            if(vm.singleData[vm.singleIndex].config.partid!=item.config.partid){
                MessageService.hint($translate.instant("editorMessage.不是相同部件的版式不可替换"));
                return
            }
            if(item.uuid != vm.singleData[vm.singleIndex].uuid){
                vm.threeLoading = true;
                vm.threeLoadingText = $translate.instant("editorCommon.loadingText2");
                item.config = vm.singleData[vm.singleIndex].config;
                var pages = {
                    config:$scope.template.config,
                    pages:{
                        page: [angular.copy(item)]
                    }
                }
                documentAnalysis($scope, $http, vm, pages,FontManagement,'processing', function(page){
                    ratioInfo(page)
                }, function () {
                    $timeout(function () {
                        var layoutPage = pages.pages.page[0];
                        layoutPage.backup = false;
                        layoutPage.unreplace = false;
                        layoutPage.quantity = vm.singleData[vm.singleIndex].quantity;
                        pageDataInfo(layoutPage)
                    },200)
                })
            }
        }
        function pageDataInfo(page) {
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText2");
            page.uuid = getUuid();
            var _pageData = angular.copy(vm.singleData[vm.singleIndex]);
            var _pageDataImageboxImage = [];
            var _pageDataImageboxImageSum = 0;
            for(var i=0; i<_pageData.levels.level.length; i++){
                var _lecel = _pageData.levels.level[i];
                if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                    _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                    _pageDataImageboxImage.push(_lecel.imagebox)
                }
            }
            if(!page.levels.level){
                page.levels.level=[];
            }
            _pageDataImageboxImage = imageboxAdapt(page.levels.level, _pageDataImageboxImage);
            angular.forEach(page.levels.level, function (level, i) {
                if (level.imagebox) {
                    var _imagebox = null;
                    for(var j=0; j<_pageDataImageboxImage.length; j++){
                        if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                            _imagebox = _pageDataImageboxImage[j];
                            break
                        }
                    }
                    _pageDataImageboxImageSum++;
                    if (_imagebox) {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.whiteInk = null;
                        level.imagebox.whiteInk2 = null;
                        level.imagebox.image = {
                            blurredrectangle: {
                                width: 0,
                                height: 0,
                                x: 0,
                                y: 0
                            },
                            resource: {
                                identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                            },
                            resourceid:_imagebox ? _imagebox.image.resourceid : '',
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            angle: 0,
                            offsetx: 0,
                            offsety: 0,
                            imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                            width: _imagebox ? _imagebox.image.width : '',
                            height: _imagebox ? _imagebox.image.height : '',
                            imgSize: _imagebox ? _imagebox.image.imgSize : '',
                            index: _imagebox ? _imagebox.image.seq : '',
                            parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                            scale: 1,
                            brightness:_imagebox ?_imagebox.image.brightness : 0,
                            contrast: _imagebox ?_imagebox.image.contrast : 0,
                            saturate: _imagebox ?_imagebox.image.saturate : 0,
                            temperature: _imagebox ?_imagebox.image.temperature : 0,
                            hue: _imagebox ?_imagebox.image.hue : 0
                        }
                        level.imagebox.blurredrectangle = {
                            width:'',
                            height:'',
                            x:'',
                            y:'',
                        };
                        if (level.imagebox.image.resource.identifier) {
                            if(vm.pictureType == 'spread'){
                                getBlurredrectangle(level.imagebox, $scope.zfInit() ? 1 : 0);
                            }else{
                                getBlurredrectangle(level.imagebox, 0);
                            }
                        }
                    } else {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.whiteInk = null;
                        level.imagebox.whiteInk2 = null;
                        level.imagebox.image = {
                            resource: {
                                identifier: '',
                                provider: ''
                            },
                            resourceid:"",
                            filterResource: {
                                identifier: '',
                                provider: ''
                            },
                            width: '',
                            height: '',
                            imgSize: '',
                            offsetx: 0,
                            offsety: 0,
                            index: '',
                            parameter: [],
                            scale: 1,
                            angle: 0,
                        }
                    }
                }
            })
            $timeout(function () {
                vm.singleData[vm.singleIndex] = page;
                vm.singleData[vm.singleIndex].backup = false;
                vm.singleData[vm.singleIndex].unreplace = false;
                vm.threeLoading = false;
                vm.threeLoadingText = '';
                MessageService.hint($translate.instant("editorCommon.changePageSuccess"));
            },200)
        }
        // 抠图
        $scope.mattingOpen = function () {
            vm.imageboxCutout = {
                image: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier,
                mattingMask: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask,
                resourceid: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resourceid,
                angle: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.angle,
                flip: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip,
            }
            vm.isShowImageCutout = true;
        };
        $scope.imageCutoutChange = function(text){
            if(text){
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
            }
        }
        $scope.imageCutoutSave = function(text){
            vm.isShowImageCutout = false;
            if(text){
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
                if(vm.propertyValue.white && vm.propertyValue.white.length){
                    setProcessImages(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox,vm.propertyValue.white[0]);
                }
            }
        }
        
        function setProcessImages(imagebox,white){
            vm.threeLoading=true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText5");
            if(imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier){
                processImages(imagebox.image.resource.identifier,null,function(res){
                    var blob = base64ToBlob(res, 'image/' + imagebox.image.imageInfo.format);
                    var _file = blobToFile(blob); 
                    ImageService.backendUploadPics(_file, $scope.domain, vm.token, function(data){
                        vm.threeLoading=false;
                        imagebox.whiteInk = null;
                        imagebox.whiteInk2 = {
                            resource:{
                                identifier:$scope.domain +data.key
                            },
                            growMethod: white.epitaxy,
                            growValue: white.epitaxyValue,
                            unit: white.unit,
                            color: white.spotColor,
                            colorValue: white.color,
                        };
                        $scope.$apply();
                    },function(err){
                        vm.threeLoading=false;
                        $scope.$apply();
                    })
                },function(error){
                    vm.threeLoading=false;
                    MessageService.error(error);
                })
            }else{
                vm.threeLoading=false;
                MessageService.error($translate.instant('chalk.message.addImageFirst'));
            }
        }
        // 是否大图
        $scope.isLarge = function(imageInfo){
            if(!imageInfo)return
            return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
        }
        function getPropertyValue(){
            vm.propertyValue = {
                white:[],
                hotStamp:[],
                uv:[],
                fluore:[],
                outline:[]
            };
            if(vm.article.editorType == 'PICTURE_PRO_P' && vm.itemValue && vm.itemValue.objectValues){
                var skuNumber = vm.itemValue.skuNumber.split('-');
                vm.itemValue.objectValues.forEach(function (object) {
                    object.propertyValues.forEach(function (propertyValue) {
                        var _skuNumber = propertyValue.propertyId + '_' + propertyValue.id;
                        if(skuNumber.indexOf(_skuNumber) > -1){
                            var processOperation = {
                                id:object.processOperationId,
                                name:object.processOperationName,
                                type:object.processOperationType,
                                epitaxy:null,
                                epitaxyValue:object.processOperationEpitaxyValue,
                                spotColor:propertyValue.spotColor,
                                operationValueAlias:propertyValue.operationValueAlias,
                                color:propertyValue.color,
                                value:propertyValue.value,
                                unit:'mm',
                                uuid: _skuNumber
                            }
                            switch (object.processOperationEpitaxy) {
                            case 'EXTENSION':
                                processOperation.epitaxy = 'expand';
                                break;
                            case 'SHRINKAGE':
                                processOperation.epitaxy = 'shrink';
                                break;
                            default:
                                processOperation.epitaxy = null;
                            }
                            if(object.processOperationUnit == 'px'){
                                processOperation.epitaxyValue = PxTurnMm(processOperation.epitaxyValue);
                            }
                            if(object.processOperationType == 'WHITE_INK'){
                                vm.propertyValue.white.push(processOperation);
                            }
                            if(object.processOperationType == 'HOT_STAMP'){
                                vm.propertyValue.hotStamp.push(processOperation);
                            }
                            if(object.processOperationType == 'UV'){
                                vm.propertyValue.uv.push(processOperation);
                            }
                            if(object.processOperationType == 'FLUORESCENT'){
                                vm.propertyValue.fluore.push(processOperation);
                            }
                            if(object.processOperationType == 'DIE_LINE'){
                                vm.propertyValue.outline.push(processOperation);
                            }
                        }
                    })
                })
            }
        }
        
        vm.operationTab = 'picture';
        $scope.operationTabCb = function(item){
            vm.operationTab = item;
        }
        vm.chalkImagebox = null;
        vm.chalkImageart = null;
        vm.chalkWidth = null;
        vm.chalkHeight = null;
        vm.chalkPropertyValue = null;
        $scope.editChalkImagebox = function(type, propertyValue){
            if(type){
                vm.chalkImageart = angular.copy($scope.getImageart(vm.singleData[vm.singleIndex],vm.operationTab, propertyValue) || {});
                vm.chalkWidth = vm.singleData[vm.singleIndex].mediabox.width;
                vm.chalkHeight = vm.singleData[vm.singleIndex].mediabox.height;
                vm.chalkPropertyValue = propertyValue;
                return
            }
            if(vm.propertyValue.white && vm.propertyValue.white.length){
                vm.chalkPropertyValue = vm.propertyValue.white[0];
            }
            if(!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier){
                MessageService.hint($translate.instant("editorCommon.pleaseAddImage"));
                return
            }
            vm.chalkImagebox = angular.copy(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox);
            vm.chalkWidth = vm.chalkImagebox.image.imageInfo.width;
            vm.chalkHeight = vm.chalkImagebox.image.imageInfo.height;
        }
        $scope.chalkChange = function(text){
            if(text){
                if(vm.operationTab == 'uv' || vm.operationTab == 'fluore'){
                    var imageart = $scope.getImageart(vm.singleData[vm.singleIndex],vm.operationTab, vm.chalkPropertyValue);
                    if(imageart){
                        imageart = text;
                    }else{
                        vm.singleData[vm.singleIndex].levels.level.push({
                            seq: vm.singleData[vm.singleIndex].levels.level.length + 1,
                            imageart: text
                        });
                    }
                }else{
                    vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox = text;
                }
            }
            vm.chalkImagebox = null;
            vm.chalkImageart = null;
        }
        
        window.uploadColor = function ($event,hotStamp) {
            var file = $event.target.files[0]; // 获取上传的文件
            if(hotStamp){hotStamp = JSON.parse(hotStamp)}
            if (!file.type.startsWith('image/png')) {
                MessageService.hint($translate.instant("editorCommon.hotStampingPngOnly", {type: file.type}));
                return;
            }
            ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data){
                imageartAdd($http, $scope.domain +data.key, vm.singleData[vm.singleIndex].trimbox, function(imageart){
                    if(vm.repeatAddNumber>4){
                        vm.repeatAddNumber = 0;
                    }
                    var _num = 10*vm.repeatAddNumber;
                    imageart.geometry.x += _num/vm.singleData[vm.singleIndex].custom.ratio1;
                    imageart.geometry.y += _num/vm.singleData[vm.singleIndex].custom.ratio1;
                    if(vm.operationTab == 'TECHNIQUE' && hotStamp){
                        imageart.spotColor = {
                            color: hotStamp.color,
                            code: hotStamp.spotColor,
                            name: hotStamp.value,
                            growMethod: hotStamp.epitaxy,
                            growValue: hotStamp.epitaxyValue,
                            unit: hotStamp.unit,
                            uuid: hotStamp.uuid
                        };
                        imageart.serviceType = "stamping";
                    }
                    var _level = {
                        seq: vm.singleData[vm.singleIndex].levels.level.length + 1,
                        imageart: imageart
                    }
                    vm.singleData[vm.singleIndex].levels.level.push(_level);
                    vm.repeatAddNumber++;
                }, vm.singleData[vm.singleIndex].custom.ratio1)
                $scope.$apply();
            },function(err){
                MessageService.error($translate.instant("editorCommon.whiteInkSizeMismatch"));
                $scope.$apply();
            })
        };
        $scope.getImageart = function(page,serviceType,propertyValue){
            var imageart = null;
            if(page && page.levels && page.levels.level){
                for(var i=0; i<page.levels.level.length; i++){
                    if(page.levels.level[i].imageart && page.levels.level[i].imageart.spotColor && page.levels.level[i].imageart.serviceType === serviceType && page.levels.level[i].imageart.spotColor.uuid == propertyValue.uuid){
                        imageart = page.levels.level[i].imageart;
                        break
                    }
                }
            }
            return imageart;
        }
        $scope.getImageartSize = function(type, propertyValue){
            var imageart = $scope.getImageart(vm.singleData[vm.singleIndex],vm.operationTab, propertyValue);
            if(imageart){
                var size = 60;
                if(imageart.geometry.width > imageart.geometry.height){
                    if(type == 'width'){
                        return size
                    }else{
                        return size * imageart.geometry.height / imageart.geometry.width
                    }
                }else{
                    if(type == 'width'){
                        return size * imageart.geometry.width / imageart.geometry.height
                    }else{
                        return size
                    }
                }
            }
        }
        $scope.goldFoil = function(color){
            if(color){
                return goldFoil(color)
            }
        }
        vm.isOutline = false;
        $scope.setOutline = function(){
            vm.isOutline = true;
        }
        $scope.outlineChange = function(text){
            vm.isOutline = false;
            if(text){
                vm.singleData[vm.singleIndex].outline = text.outline;
                if(vm.product.pictureType == 'spread' && vm.singleData[vm.singleIndex+1]){
                    vm.singleData[vm.singleIndex+1].outline = text.outlineSpread;
                }
            }
        }
        // 保持反面统一
        vm.sideUnification = false;
        $scope.backConsistentCb = function(index){
            vm.sideUnification = !vm.sideUnification;
            if(vm.sideUnification){
                sideUnification(index)
            }
        }
        function sideUnification(index){
            if(!index){
                index = 0;
            }
            if(vm.page3){
                if(index % 2 === 1){
                    vm.singleData.forEach(function(data,dataIndex){
                        if(dataIndex != index && dataIndex % 2 === 1){
                            var _page = JSON.parse(JSON.stringify(vm.singleData[index]));
                            var outline = JSON.parse(JSON.stringify(data.outline));
                            var uuid = JSON.parse(JSON.stringify(data.uuid));
                            vm.singleData[dataIndex] = _page;
                            vm.singleData[dataIndex].outline = outline;
                            vm.singleData[dataIndex].uuid = uuid;
                        }
                    })
                }
            }else{
                vm.data.forEach(function(data,dataIndex){
                    if(dataIndex != index){
                        var _page = JSON.parse(JSON.stringify(vm.data[index][1]));
                        var outline = JSON.parse(JSON.stringify(data[1].outline));
                        data[1] = _page;
                        data[1].outline = outline;
                        data[1].uuid = data[0].uuid;
                    }
                })
            }
        }
    }
})();
